import { AmplitudeEvent } from "./AmplitudeEvent";
import { BookData, BookDataCreate } from "./types";

export enum AppEvents {
  APP_LAUNCHED = "Web_usage_app_launched",
  APP_OPENED = "Web_usage_app_opened",
}

interface AppLaunched extends AmplitudeEvent {
  event: AppEvents.APP_LAUNCHED;
}

interface AppOpened extends AmplitudeEvent {
  event: AppEvents.APP_OPENED;
}

export enum BookEvents {
  BOOK_COMPLETED = "Web_usage_book_completed",
  BOOK_CREATED = "Web_usage_book_created",
  BOOK_FAILED = "Web_usage_book_failed",
  BOOK_START_PROCESSING = "Web_usage_book_start_processing",
  BOOK_STARTED = "Web_usage_book_started",
}

interface BookCompleteListening extends AmplitudeEvent {
  event: BookEvents.BOOK_COMPLETED;
  data: BookData;
}

interface BookCreated extends AmplitudeEvent {
  event: BookEvents.BOOK_CREATED;
  data: BookDataCreate & {
    book_create_pathway: "web";
    book_create_time_spent: number;
    book_create_processing_time?: number;
  },
}

interface BookFailed extends AmplitudeEvent {
  event: BookEvents.BOOK_FAILED;
  data: BookDataCreate & {
    book_create_pathway: "web";
  },
}

interface BookStartListening extends AmplitudeEvent {
  event: BookEvents.BOOK_STARTED;
  data: BookData;
}

interface BookStartProcessing extends AmplitudeEvent {
  event: BookEvents.BOOK_START_PROCESSING;
  data: BookDataCreate & {
    book_create_pathway: "web";
    processing_percentage: number;
  };
}

export enum WordsEvents {
  WORDS_LISTENED = "Web_usage_words_listened",
}

interface WordsListened extends AmplitudeEvent {
  event: WordsEvents.WORDS_LISTENED;
  data: {
    book_id: string;
    voice_name: string;
    increment: number;
    num_words_lifetime: number;
    avg_wpm: number;
    is_background: 1 | 0;
    is_hd: 1 | 0;
  };
}

export enum TabEvents {
  TAB_TAPPED = "Web_usage_tab_tapped",
}

interface TabTapped extends AmplitudeEvent {
  event: TabEvents.TAB_TAPPED;
}

export type AmplitudeEvents = (
  AppLaunched
  | AppOpened
  | BookCompleteListening
  | BookCreated
  | BookFailed
  | BookStartListening
  | TabTapped
);
